import { render } from "./ExpansionPanelContent.vue?vue&type=template&id=06a6ad75"
import script from "./ExpansionPanelContent.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__